// Sharing one badge: the card (shareCard.ts), its text twin, and the tagged
// link the arrival is counted by (utm_medium=badge, utm_content=<badge>_<tier>).
import { renderBadgeShareCard } from './shareCard';
import { shareCard, type ShareDone } from './shareFlow';
import { WEB_ORIGIN } from './invite';
import { badgeArt, badgeSpec, earnedLine, rarityLine, tierLabel, TIER_LABEL, TIER_METAL, type BadgeState, type Tier } from './badges';

export function badgeShareUrl(id: string, tier: Tier): string {
  return `${WEB_ORIGIN}/?utm_source=share&utm_medium=badge&utm_content=${id.toLowerCase()}_${tier}`;
}

/** Shares the card; `text` is the message with its link, for a preview's COPY TEXT. */
export async function shareBadge(state: BadgeState, nickname: string): Promise<ShareDone & { text: string }> {
  const tier = (state.tier || 1) as Tier;
  const spec = badgeSpec(state.id);
  const rarity = rarityLine(state.held);
  const line = earnedLine(state.id, tier);
  const text = [
    `World of Trivia: ${spec.name}${spec.tiers > 1 ? `, ${TIER_LABEL[tier].toLowerCase()}` : ''}`,
    line,
    ...(rarity ? [rarity] : []),
    'Your turn.',
  ].join('\n');

  let blob: Blob | null = null;
  try {
    blob = await renderBadgeShareCard({
      name: spec.name,
      tierLabel: tierLabel(spec, tier),
      tierColor: spec.tiers > 1 ? TIER_METAL[tier] : TIER_METAL[3],
      line,
      rarity,
      artUrl: badgeArt(state.id, tier),
      nickname,
      date: new Date().toLocaleDateString('en-GB', { day: 'numeric', month: 'short', year: 'numeric' }).toUpperCase(),
    });
  } catch { /* the text still goes */ }

  const url = badgeShareUrl(state.id, tier);
  const done = await shareCard({
    card: 'badge',
    blob,
    fileName: 'wot-badge.png',
    text,
    url,
    dialogTitle: 'Share your badge',
    web: 'preview',
    props: { badge: state.id, tier },
  });
  return { ...done, text: `${text}\n${url}` };
}
